export default {
  xzsj: 'ກະລຸນາເລືອກວັນທີ່',//选择时间
  qsr:'ກະລຸນາຕື່ມຂໍ້ມູນ',//请输入
  qxz:'ກະລຸນາເລືອກ',//请选择
  zwsj: 'ບໍ່ມີຂໍ້ມູນເພີ້ມ',//暂无数据
  yxqgq: 'ຄວາມຕ້ອງການປະຈໍາເດືອນເກີນວັນທີດໍາເນີນການ ແລະ ບໍ່ສາມາດນໍາໃຊ້ໄດ້!',

  gjly: 'ຂົນສົ່ງລະຫວ່າງປະເທດ',//国际联运
  gnys: 'ຂົນສົ່ງພາຍໃນປະເທດ',//国内运输
  jdxq: 'ຂະບວນການຕ້ອງການ',//阶段需求
  yxqh:'ເລກຄວາມຕ້ອງການປະຈຳເດືອນ',//月需求号
  xqdh: 'ເລກຄວາມຕ້ອງການ',//需求单号
  faz: 'ສະຖານີລົດໄຟທີ່ສົ່ງອອກ',//发站
  daoz: 'ສະຖານີປາຍທາງ',//到站
  pm: 'ຊື່ສິນຄ້າ',//品名
  hwmc:'ຊື່ສິນຄ້າ',//货物名称
  kydcs: 'ການສຽດສີ',//可预定车数

  fhxx: 'ຂໍ້ມູນການສົ່ງສິນຄ້າ',//发货信息
  shxx: 'ຂໍ້ມູນຮັບສິນຄ້າ',//收货信息
  jbr: 'ຮູບແບບ່ວໄປ',//经办人
  hz:'ການກ່ຽວພັນຂອງຕົວແທນຂົນສົ່ງສິນຄ້າ',//货主
  tyrjs:'ບົດລາຍງານຂອງຜູ້ຂົນສົງສີນຄ້າ',//托运人记事
  zjh:'ເລກບັດ',//证件号
  tyr:'ຜູ້ຝາກເຄື່ອງ',//托运人
  jbrsj: 'ເບີໂທຜູ້ດຳເນີນການ',//经办人手机
  zzzmwj:'ເອກະສານຢັ້ງຢືນ',//资质证明文件
  mc:'ຊື່ ',//名称
  hm:'số',//号码
  zcdd: 'ຈຸດຄ່ຽນຖ່າຍຂື້ນລົດໄຟ',//装车地点
  xcdd: 'ຈຸດຄ່ຽນຖ່າຍລົງລົດໄຟ',//卸车地点
  scfj: 'ຕິດຕັ້ງຂໍ້ມູນ',//上传附件
  cyshf:'ມັກໃຊ້ປະຈຳໃນການຮັບສີນຄ້າ',//常用收货方
  shr: 'ຜູ້ຮັບເຄື່ອງ',//收货人
  txdz: 'ທີ່ຢູ່',//通讯地址
  fkxx:'ຂໍ້ມູນບັນຊີຊຳລະເງີນລວ່ງໜ້າ',//付款信息
  yfk: 'ບັນຊີຊຳລະເງີນລວ່ງໜ້າ',//预付款
  xj:'ເງີນສົດ',//现金
  fkr:'ຜູ້ຈ່າຍເງິນ',//付款人
  zffs: 'ວິທີຈ່າຍເງີນ',//支付方式
  bzxz: 'ເລືອກປະເພດເງີນ',//币种选择
  biz:'ປະເພດສະກຸນເງິ ',//币种
  jp: 'ກີບ',//基普
  rmb: 'ຢວນ',//人民币
  meij: 'ໂດລາ',//美元
  ldwl: 'ການຂົນສົງລະຫວ່າງສະຖານີຕົ້ນທາງກັບປາຍທາງ',//两端物流
  ldwlw: 'ອີງຕັ້ງຕ້ອງການທ່ານ, ເລືອກສະຖານີຕົ້ນທາງກັບປາຍທາງໃນການໄປຮັບ-ສົງ,ສາງແລະບໍລິການຂົນສົງອື່ນໆ.',//两端物流
  qk: 'ລົບຂໍ້ມູນທັງໝົດ',//清空
  tj: 'ສົ່ງອອກ',//提交

  xl: 'ຊະນິດຕູ້',//箱类
  xx: 'ຂະໜາດຕູ້',//箱型
  zaiz: 'ຕິດຕັ້ງ',//载重
  ziz:'ນ້ຳໜັກຕູ້ເປົ່າ',//自重
  jwjtdcc:'ກະລຸນາໃສ່ແຟ້ມໃສ່ນ, ຫລືອ',//将资源文件拖到此处，或
  djsc:'ຄລິກເພື່ອອັບໂຫລດ',//点击上传
  hang:'ໄຫວ',//行
  xhgscw:'ເລກໂຕເລກ, ມີຮູບແບບຜິດພາດ(es)',//箱号，格式错误
  zhyw:'ເລກໂຕເລກ(es)',//最后一位
  ddxx:"ຂໍ້ມູນເພີ້ມຄຳສັ່ງ(es)",//订单信息
  qhjqkbd:'ການປ່ຽນປະເພດການຂົນສົ່ງຈະລຶບລ້າງເນື້ອຫາທີ່ເຕັມ, ກະລຸນາຢືນຢັນ!',
  md:'ບໍ່ເຕນ',//磨丁
  nd:'ນາເຕີຍ',//纳堆
  lblb:'ຫຼວງພະບາງ',//琅勃拉邦
  wxn:'ວຽງຈັນໃຕ້',//万象南
  mengs:'ເມືອງໄຊ',
  gax:'ກາສີ',
  wanr:'ວັງວຽງ',
  pengh:'ໂພນໂຮງ',
  moh: 'ບໍ່ຫ່ານ',
  hq:'ໄດ້ຮັບ',
  hsxx:'ຢືນຢັນຂໍ້ມູນ',

  gryhwfblgjlyyw:'ຜູ້ໃຊ້ສ່ວນບຸກຄົນບໍ່ສາມາດຈັດການກັບການບໍລິການຂົນສົ່ງສາກົນໄດ້!',
  gryhbzgrshqhqyhh: '个人用户无法办理国际联运业务，请确定与企业绑定经办人，并在个人设置-用户切换中切换成企业用户',
  bqhcqyyhdl:'当前登录用户无发货权限，请确定与企业绑定经办人，并切换成企业用户登录',
  czsb:'ການດໍາເນີນງານລົ້ມເຫລວ',
  zyjs:'ບັນທຶກອິດສະລະ',
  fkfs:'ວິທີການຊໍາລະເງິນ',
  yjyf:'预计运费',
  dqyhwfhqx:'ຜູ້​ໃຊ້​ທີ່​ເຂົ້າ​ສູ່​ລະ​ບົບ​ໃນ​ປັດ​ຈຸ​ບັນ​ບໍ່​ມີ​ສິດການ​ຈັດ​ສົ່ງ​ ແລະ​ ບໍ່​ສາ​ມາດ​​ທີ່​ຈະ​ຈັດ​ການ​ທຸ​ລະ​ກິດ​ຊົ່ວ​ຄາວ!',
  bxwdy0os:'ຕ້ອງເປັນຕົວເລກຄູ່ທີ່ໃຫຍ່ກວ່າ 0!',
  qsrtdyy:'ກາລຸນາລະບຸ ເຫດຜົນການຍົກເລີກ ການສັ່ງຈອງ!',
  bytd:'ການຍົກເລີກ ການສັ່ງຈອງ ໃນເດືອນນີ້',
  tdtip:'ຈໍານວນຄັ້ງ,ຫຼັງຈາກຄົບ5ຄັ້ງແລ້ວ, ບໍ່ສາມາດເພີ່ມຄວາມຕ້ອງໃໝ່ໃນເດືອນໄດ້ອີກ !',
  tdtip2:'ຈໍານວນຄັ້ງ,ຫຼັງຈາກຄົບ5ຄັ້ງແລ້ວ, ບໍ່ສາມາດເພີ່ມຄວາມຕ້ອງໃໝ່ໃນເດືອນໄດ້ອີກ !',
  jdxqsywb:'ຄວາມຕ້ອງການໃນຂັ້ນຕອນນີ້ແມ່ນນໍາໃຊ້ໝົດແລ້ວ, ກາລຸນາເລີອກຂັ້ນຕອນອື່ນ ເພື່ອດໍາເນີນການ ຂຽນຟອມ !',
  zntjdtbsj:'ສາມາດສົ່ງຂໍ້ມູນໄດ້ເທົ່ານັ້ນ !',
  zkxzytdd:'Only one piece of data can be selected!',
  yxbtitle2:'只可操作本月及下月的订单!',
  qxzsltgddd:'ກະລຸນາເລືອກໃບບິນທີ່ຜ່ານການຈັດການແລ້ວ!',
  qxsrsjh:'ກະລຸນາໃສ່ເບີໂທລະສັບກ່ອນ',
  qzssr3wzf:'请至少输入三位数字(lo)',
  jsqdlx:'ປະເພດການຮັບສົ່ງສິນຄ້າເຖິງທີ່',
}
